<template>
    <div>
        <div class="modal fade" :id="modalId" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $lang('Zdjęcia') }}</h5>
                        <button type="button" class="close" data-dismiss="modal" :aria-label="$lang('Zamknij')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row col-12">
                            <input class="d-none" type="file" id="new-image-input" ref="new-image-input" v-on:change="uploadImage"/>
                            <button type="button" class="btn btn-primary"
                                    onclick="document.getElementById('new-image-input').click();">{{ $lang('Nowe zdjęcie') }}
                            </button>
                        </div>
                        <table v-if="imagesData && imagesData.length > 0" class="table simple-table table-striped table-sm mt-3">
                            <thead class="thead-dark">
                            <tr>
                                <th scope="col">{{ $lang('Zdjęcie') }}</th>
                                <th scope="col">{{ $lang('Nazwa pliku') }}</th>
                                <th scope="col">{{ $lang('Akcje') }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="image in imagesData">
                                <td :data-title="$lang('Zdjęcie')" class="align-middle">
                                    <img :alt="$lang('Reklama')" :src="image.path" style="height: 70px"/>
                                </td>
                                <td :data-title="$lang('Nazwa pliku')" class="align-middle">
                                    <span>{{ image.name }}</span>
                                </td>
                                <td :data-title="$lang('Akcje')" class="align-middle">
                                    <button type="button" class="btn btn-default" v-on:click="imageToDelete=image"
                                            data-toggle="modal" :data-target="'#'+deleteModalId">
                                        {{ $lang('Usuń') }}
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div v-else class="row col-12 mt-3 font-weight-bold">{{ $lang('Brak zdjęć') }}</div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal" id="close-slider-images-modal">
                            {{ $lang('Zamknij') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade modal-in-modal" :id="deleteModalId" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content" v-if="imageToDelete">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $lang('Usunięcie zdjęcia') }}</h5>
                        <button type="button" class="close" data-dismiss="modal" :aria-label="$lang('Zamknij')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div>{{ $lang('Czy na pewno chcesz usunąć zdjęcie') + ' ' }}<b>{{ imageToDelete.name }}</b>{{ '?' }}</div>
                        <div class="mt-1">
                            <b>{{ $lang('Uwaga!') }}</b>
                            {{ $lang('Sprawdź czy zdjęcie jest powiązane z reklamami. Usunięcie zdjęcia przypisanego do reklamy spowoduje niewyświetlanie go w reklamie.') }}
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">
                            {{ $lang('Nie') }}
                        </button>
                        <button class="btn btn-primary" @click="deleteImage" data-dismiss="modal">
                            {{ $lang('Tak') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ShowNotification from "../../mixins/show-notification";

export default {
    name: "slider-images-modal",
    mixins: [ShowNotification],
    props: {
        modalId: {
            type: String,
            required: true
        },
        value: {
            type: Array,
            required: false
        },
        uploadImageRoute: {
            type: String,
            required: true
        },
        deleteImageRoute: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            imagesData: this.value ?? [],
            imageToDelete: null,
            deleteModalId: 'delete-image-modal'
        }
    },
    methods: {
        uploadImage() {
            let file = this.$refs['new-image-input'].files[0];
            let formData = new FormData();
            formData.append('image', file);

            let self = this;
            axios.post(this.uploadImageRoute, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {
                self.imagesData = response.data;
                self.showNotification('success', 'Dodano zdjęcie do bazy!');
            }).catch(function (error) {
                console.log(error);
                self.showNotification('error', 'Dodanie zdjęcia nie powiodło się!')
            });
        },
        deleteImage() {
            let self = this;
            let data = {
                imageName: this.imageToDelete.name
            };

            axios.delete(this.deleteImageRoute, {data})
                .then(function (response) {
                    self.imageToDelete = null;
                    self.imagesData = response.data;
                    self.showNotification('success', 'Zdjęcie zostało usunięte!');
                })
                .catch(function (error) {
                    console.log(error);
                    self.showNotification('error', 'Nie udało się usunąć zdjęcia!');
                });
        }
    },
    watch: {
        imagesData() {
            this.$emit('input', this.imagesData);
        }
    },
}
</script>
